/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import MSDyBaseCartesian from './msdybasecartesian';
import { ParetoColumnDataset } from '../_internal/datasets/pareto';
import { ParetoLineDataset } from '../_internal/datasets/paretoline';
import axisFactory from '../_internal/factories/pareto-axis';
import { preDefStr } from '../_internal/lib/lib';
import datasetFactory from '../_internal/factories/pareto-dataset';

let NINETYSTRING = preDefStr.NINETYSTRING;
/**
 * Set categories to Axis
 */
function _setCategories () {
  var iapi = this,
    dataObj = iapi.getFromEnv('dataSource'),
    dataset = dataObj.dataset,
    numberFormatter = iapi.getFromEnv('number-formatter'),
    xAxis = iapi.getChildren('xAxis'),
    data = dataObj.data || (dataset && dataset[0].data) || [],
    catArr = [],
    datum,
    dataLen = data.length,
    i,
    vLine = {};

  // iterate all data and remove null and vlines
  for (i = dataLen - 1; i >= 0; i--) {
    datum = data[i];
    if (datum.vline === 'true' || datum.vline === '1' || datum.vline === 1 ||
                datum.vline === true) {
      vLine[i] = datum;
      data.splice(i, 1);
    } else if (numberFormatter.getCleanValue(datum.value, true) === null) {
      data.splice(i, 1);
    }
  }

  // Sort the original data
  data.sort(function (a, b) {
    return numberFormatter.getCleanValue(b.value, true) - numberFormatter.getCleanValue(a.value, true);
  });

  // clone the sorted data for categories
  catArr = data.slice();
  // add the v lines
  for (i in vLine) {
    catArr.splice(i, 0, vLine[i]);
  }
  xAxis[0].setTickValues(catArr);
}

/**
 * Creates class for  Pareto2D
 */
class Pareto2D extends MSDyBaseCartesian {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'Pareto2D';
  }
  /**
   * Constructor function for class Pareto2D
   */
  constructor () {
    super();
    this.isPercentage = true;
    this.registerFactory('axis', axisFactory, ['canvas']);
    this.registerFactory('dataset', datasetFactory, ['vCanvas']);
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'Pareto2D';
  }
  /**
   * parse defualt configuration of the chart
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.singleseries = true;
    config.hasLegend = false;
    config.defaultDatasetType = 'column';
    config.plotfillalpha = NINETYSTRING;
    config.enablemousetracking = true;
  }
  /**
   * parse defualt configuration of the chart
   */
  _setCategories () {
    _setCategories.call(this);
  }
  /**
   * function to check if the chart specific data is proper is not
   * this fn is define for specific chart types
   * @return {boolean} if JSON data is valid or not
   */
  _checkInvalidSpecificData () {
    let jsonData = this.getFromEnv('dataSource'),
      data = jsonData.data;
    if (!data || !data.length) {
      return true;
    }
  }
  /**
   * This method return the dataset definations for this charts
   * @param {string} name Name of dataset class
   * @return {Class}       Pareto dataset
   */
  getDSdef (name) {
    return name === 'column' ? ParetoColumnDataset : ParetoLineDataset;
  }
  /**
   * Overrides parent fn
   */
  getDSGroupdef () {
    // this fn overrides
  }
}
export default Pareto2D;
export { _setCategories };
